/**
 * See list of weblabs in ARMS BFF here:
 * https://tiny.amazon.com/sf2ltd0/codeamazpackAdveblobmainsrc
 */
export enum Weblab {
  ADAM_POLICY_15_AUTHENTICATION_LAUNCH = 'ADAM_POLICY_15_AUTHENTICATION_LAUNCH_1012515',
  SINGLE_GLOBAL_ACCOUNT_LAUNCH = 'SINGLE_GLOBAL_ACCOUNT_LAUNCH_1212308',
  HELP_ME_HERE_SGA_TOOLTIP = 'HELP_ME_HERE_SGA_TOOLTIP_1318037',
  ACCOUNT_COMBINATION = 'ARMS_COMBINATION_1377682',
  COMBINE_REQUEST_ACCESS = 'COMBINE_REQUEST_ACCESS_1459186',
}

export enum WeblabTreatment {
  C = 'C',
  T1 = 'T1',
}
